module.exports = __webpack_public_path__ + "img/4.92f5048c.jpg";